export const ENABLED_FOREX_QUOTES = [
    "SEK",
    "USD",
    "CAD",
    "NZD",
    "EUR",
    "GBP",
    "NOK",
    "DKK",
    "AUD",
    "LBP",
    "TRY",
    "UAH",
    "RUB",
    "LEK",
    "ALL", // LEK
    "BAM",
    "INR"
];
export const FOREX_QUOTE_ALIASES = {
    'LEK': 'ALL',
    'ALL': 'LEK'
};
